import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import PaginationManager from "../../view/PaginationManager";
import { InventoryConfigManagement } from "./InventoryConfigManagement";
import InventoryScanTableHeader from "./InventoryScanTableHeader";
import InventoryScanTable from "./InventoryScanTable";
import * as inventoryService from "./inventoryService";
import PortsCardModal from "./ports/PortsCardModal";

function InventoryTableSection() {

    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [modalProps, setModalProps] = useState({});

    const handleShowModal = (props) => {
        setModalProps(props);
        setShowModal(true);
    }
    const onCloseModal = () => {
        //history.go(0);
        setTableConfig({ ...tableConfig, lastUpdated: Date.now() });
        setShowModal(false);
    }
    const initTableConfig = {
        selected: [],
        //osChanged: '',
        showModal: handleShowModal
    }

    // results: [],
    // allResults: [],

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return ( 
        <>
            {showModal && <PortsCardModal handleClose={onCloseModal} {...modalProps} />}       
            <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
                <InventoryConfigManagement />
                <div className="container-fluid" key={history.location}>
                    <div className="row">
                        <div className="col-12">
                            <div className="card oct_table-card-v2 network-scan-table-card-v2">
                                <InventoryScanTableHeader />
                                <div className="card-body">
                                    <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                        <div className="row">
                                            <div className="col-sm-12 p-0">
                                                <InventoryScanTable />
                                                <PaginationManager
                                                    getPage={inventoryService.listPageable}
                                                    blocked={tableConfig.filtersLoading} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </TableContext.Provider>
        </>
    )
}

export default InventoryTableSection;
